import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export function ProtectedRoute({ children, adminOnly = false }) {
    const { user, loading } = useAuth();
    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-aura-bg">
                <div className="cyber-spinner" />
            </div>
        );
    }
    if (!user) return <Navigate to="/login" replace />;
    if (!user.emailVerified) return <Navigate to="/check-email" replace />;
    if (adminOnly && !user.isAdmin) return <Navigate to="/dashboard" replace />;
    return children;
}

